import { Component, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'adp-platform-menu',
  templateUrl: './platform-menu.component.html',
  styleUrl: './platform-menu.component.scss'
})
export class PlatformMenuComponent {
  @Input() items: any[] = [];

  visibleItems: any[] = [];

  ngOnInit(): void {
    this.visibleItems = this.items || [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items']) {
      this.visibleItems = this.items || [];
    }
  }

  openLink(item: any): void {
    if (!item?.medio_plat_valor) return;
    const url = item.medio_plat_valor.startsWith('http')
      ? item.medio_plat_valor
      : `https://${item.medio_plat_valor}`;
    window.open(url, '_blank');
  }

  copyLink(item: any): void {
    if (!item?.medio_plat_valor) return;
    navigator.clipboard.writeText(item.medio_plat_valor);
  }
}
